export const PHONE_DISPLAY = "+39 349 547 0717";
export const WHATSAPP_URL =
  "https://wa.me/393495470717?text=Ciao!%20Vorrei%20informazioni%20e%20disponibilit%C3%A0%20per%20soggiornare%20a%20Casa%20Paola%20Arcore.";
export const ADDRESS_DISPLAY = "Via Baracca 15, Arcore (MB)";
export const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=Via+Baracca+15,+20862+Arcore+MB,+Italia";
export const MAPS_EMBED_URL =
  "https://www.google.com/maps?q=Via+Baracca+15,+20862+Arcore+MB,+Italia&output=embed";

export const IMAGES = {
  esterno: "/images/esterno.jpg",
  soggiorno: "/images/soggiorno.jpg",
  pranzo: "/images/pranzo.jpg",
  cucina: "/images/cucina.jpg",
  bagnoVasca: "/images/bagno-vasca.jpg",
  camera: "/images/camera.jpg",
  bagnoLavabo: "/images/bagno-lavabo.jpg",
};

export const NAV_IDS = ["appartamento", "comfort", "galleria", "recensioni", "distanze", "contatti"];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
